import { Result } from '@uppy/transloadit';
import { UcsSdk } from '@brandfolder/ucs-sdk-browser';

export interface UppyUploaderProps {
  handleUpload: (files: Result[]) => void;
  uniqIdentifier: string;
  trigger?: `#${string}`; // Required for modal mode, optional for inline mode
  uploadLinkKey?: string; // Required for guest upload flow only
  button?: boolean;
  closeOnComplete?: boolean;
  locale?: {
    strings: {
      dropHereOr: string;
      browse: string;
    }
  };
  endpoint?: string;
  restrictions?: {
    maxNumberOfFiles?: number;
    maxFileSize?: number;
    allowedFileTypes?: string[];
  };
  template?: string;
  ucsSdk?: UcsSdk;
  inline?: boolean; // When true, renders inline dashboard instead of modal
  guestUpload?: boolean; // When true, renders guest upload
};
